import { create } from "zustand";
import { configurePersist } from "zustand-persist";

const { persist: _persist } = configurePersist({
  storage: sessionStorage,
  rootKey: "root",
});

const persist = _persist as any;

interface Auth {
  isAuthenticated?: boolean;
  accessToken?: string;
  email?: string;
  name?: string;
  id?: string;
  hasLoggedOut?: boolean;
}
interface AuthStore extends Auth {
  setAuth: (auth: Auth | ((auth: Auth) => Auth)) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthStore>(
  persist(
    {
      key: "auth",
    },
    (set: any) => ({
      isAuthenticated: false,
      accessToken: undefined,
      email: undefined,
      name: undefined,
      id: undefined,
      hasLoggedOut: false,
      setAuth: (auth: Auth | ((auth: Auth) => Auth)) => {
        if (typeof auth === "function") {
          set((_state: Auth) => auth(_state));
        } else {
          // Reset hasLoggedOut whenever the user actively authenticates
          set((_state: Auth) => ({ ...auth, hasLoggedOut: false }));
        }
      },
      clear: () => {
        set((_state: Auth) => ({
          isAuthenticated: false,
          accessToken: "",
          name: "",
          email: "",
          id: "",
          hasLoggedOut: true,
        }));
      },
    })
  )
);

export const getAuthStore = () => useAuthStore.getState();